import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "flex items-center mb-4" };
const _hoisted_2 = { class: "flex px-1" };
const _hoisted_3 = { class: "flex-1" };
const _hoisted_4 = {
    key: 0,
    class: "error-message"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_CampaignForm = _resolveComponent("CampaignForm");
    const _component_Loading = _resolveComponent("Loading");
    return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, [
            _cache[2] || (_cache[2] = _createElementVNode("h1", null, "Edit Campaign", -1)),
            _createElementVNode("nav", null, [
                _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] =
                        //@ts-ignore
                        (...args) => (_ctx.form.navigation.goBack && _ctx.form.navigation.goBack(...args))),
                    type: "button",
                    class: "alt"
                }, "Go Back")
            ])
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "top-help-block" }, [
            _createElementVNode("div", null, [
                _createElementVNode("span", { class: "text-brand-600" }, "*"),
                _createTextVNode(" denotes required field ")
            ])
        ], -1)),
        (_ctx.form.isLoaded())
            ? (_openBlock(), _createElementBlock("form", {
                key: 0,
                action: "#",
                method: "post",
                enctype: "multipart/form-data",
                onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event) => (_ctx.form.update()), ["prevent"]))
            }, [
                _createVNode(_component_CampaignForm, {
                    value: _ctx.form,
                    edit: true
                }, null, 8, ["value"]),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        (_ctx.form.noFieldErrors())
                            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.form.getErrorMessage()), 1))
                            : _createCommentVNode("", true)
                    ]),
                    _cache[3] || (_cache[3] = _createElementVNode("div", null, [
                        _createElementVNode("button", { type: "submit" }, "Update Campaign")
                    ], -1))
                ])
            ], 32))
            : (_openBlock(), _createBlock(_component_Loading, { key: 1 }))
    ]));
}
